'use client'

import React from 'react'
import { useTranslations } from 'next-intl'
import Icon from '../../atoms/Icon/Icon.component'
import SearchInput from '../../molecules/SearchInput/SearchInput.component'
import FilterSelect from '../../molecules/FilterSelect/FilterSelect.component'
import SortSelect from '../../molecules/SortSelect/SortSelect.component'
import { ResourceHubFiltersBarProps } from '../../../models/organisms/ResourceHub'
import * as S from './ResourceHub.styles'
import { Paragraph } from '../../atoms/Typography/Typography.styles'

function ResourceHubFiltersBar({
  filters,
  activeFilters,
  onFilterToggle,
  onFilterClear,
  onSearch,
  onSearchChange,
  searchQuery,
  onOpenFiltersModal,
  colorScheme,
  totalItems,
  sortOrder,
  onSortChange,
  onClearAllFilters,
}: ResourceHubFiltersBarProps) {
  const t = useTranslations('resourceHub')
  const hasActiveFilters = Object.keys(activeFilters).length > 0

  return (
    <S.ResourceHubFiltersBar>
      <S.ResourceHubFiltersBarSearch>
        <SearchInput
          label={t('searchLabel')}
          submitButtonLabel={t('submitSearch')}
          placeholder={t('searchPlaceholder')}
          value={searchQuery}
          onSearch={onSearch}
          onChange={onSearchChange}
        />
        <S.FilterIconButton
          type="button"
          onClick={onOpenFiltersModal}
          aria-label={t('openFilters')}
          colorScheme={colorScheme}
        >
          <Icon name="filters" aria-hidden />
        </S.FilterIconButton>
      </S.ResourceHubFiltersBarSearch>

      <S.ResourceHubFiltersBarSelects>
        {filters && Object.entries(filters).map(([key, value]) => {
          const selectedValues = activeFilters[key] as string[] | undefined ?? []

          return (
            <FilterSelect
              colorScheme={colorScheme}
              key={key}
              label={key}
              options={value}
              selectedValues={selectedValues}
              onToggle={(value) => onFilterToggle(key, value)}
              onClear={() => onFilterClear(key)}
            />
          )
        })}

        <SortSelect
          colorScheme={colorScheme}
          value={sortOrder}
          onChange={onSortChange}
          regionLabel={t('sort.label')}
        />
      </S.ResourceHubFiltersBarSelects>

      <S.ResourceHubFiltersBarTotalItems>
        <Paragraph typo="paragraphMD" colorScheme={colorScheme}>
          {totalItems} {t('items')}
        </Paragraph>
        {hasActiveFilters && (
          <S.ClearAllFiltersButton type="button" onClick={onClearAllFilters}>
            {t('clearAllFilters')}
          </S.ClearAllFiltersButton>
        )}
      </S.ResourceHubFiltersBarTotalItems>
    </S.ResourceHubFiltersBar>
  )
}

export default ResourceHubFiltersBar
